import { render, staticRenderFns } from "./style8.vue?vue&type=template&id=3594d686&scoped=true&"
import script from "./style8.vue?vue&type=script&lang=js&"
export * from "./style8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3594d686",
  null
  
)

export default component.exports